module.exports = __webpack_public_path__ + "static/img/teachingvideo.d18cb22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle/teachingvideo.png
// module id = 2ZaF
// module chunks = 2